import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ClickOutsideModule } from 'ng-click-outside';
import { ProgressBarModule } from 'primeng/progressbar';
import { TabsModule } from 'primeng/tabs';
import { TooltipModule } from 'primeng/tooltip';

import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { TakeOverModule } from '../../Common/TakeOver/take-over.module';
import { AbstractHypeService } from '../../Common/Layout/services/abstract-hype.service';
import { PageBuilderModule } from '../../Common/PageBuilder/page-builder.module';
import { TargetingSharedModule } from '../../Common/TargetingShared/targeting-shared.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { AmplifySharedModule } from '../AmplifyShared/amplify-shared.module';
import { SocialLinkFieldComponent } from './components/SocialLinkField/social-link-field.component';
import { SocialLinksStyleFieldComponent } from './components/SocialLinksStyleField/social-links-style-field.component';
import { WireComponent } from './components/wire.component';
import { WireConfirmationComponent } from './components/WireConfirmation/wire-confirmation.component';
import { WireContactEditorComponent } from './components/WireContactEditor/wire-contact-editor.component';
import { PACreateDialogComponent } from './components/WireCreateDialog/PACreateDialog/pa-create-dialog.component';
import { WireCreateDialogComponent } from './components/WireCreateDialog/wire-create-dialog.component';
import { WireExportDialogComponent } from './components/WireExportDialog/wire-export-dialog.component';
import { WireFakeBlockComponent } from './components/WireFakeBlock/wire.fake.block.component';
import { WireHeaderComponent } from './components/WireHeader/wire.header.component';
import { WireHeaderEditorComponent } from './components/WireHeaderEditor/wire-header-editor.component';
import { WirePreviewDialogComponent } from './components/WirePreviewDialog/wire-preview-dialog.component';
import { WireRegionSelectComponent } from './components/WireRegionSelect/wire-region-select.component';
import { WireRegionSelectDialogComponent } from './components/WireRegionSelectDialog/wire-region-select-dialog.component';
import { WireReportComponent } from './components/WireReport/wire-report.component';
import { WireReportService } from './components/WireReport/wire-report.service';
import { WireCompositionReportComponent } from './components/WireReport/WireCompositionReport/wire-composition-report.component';
import { WirePerformanceReportComponent } from './components/WireReport/WirePerformanceReport/wire-performance-report.component';
import { WireHypeService } from './services/wire-hype.service';
import { WirePageBuilderService } from './services/wire-page-builder.service';
import { WireService } from './services/wire.service';
import { WirePlainTextService } from './services/plain-text.service';


@NgModule({
    imports: [
        LocalizationModule,
        PageBuilderModule,
        TabsModule,
        CommonModule,
        FormsModule,
        MiscModule,
        ClickOutsideModule,
        CommonFormsModule,
        LayoutModule,
        CoreDialogsModule,
        CommonBasicModule,
        TooltipModule,
        TargetingSharedModule,
        ProgressBarModule,
        AmplifySharedModule,
        TakeOverModule
    ],
    declarations: [
        WireComponent,
        WireCreateDialogComponent,
        WireConfirmationComponent,
        WireHeaderComponent,
        WireHeaderEditorComponent,
        WirePreviewDialogComponent,
        WireReportComponent,
        WirePerformanceReportComponent,
        WireExportDialogComponent,
        WireCompositionReportComponent,
        WireContactEditorComponent,
        WireFakeBlockComponent,
        SocialLinkFieldComponent,
        PACreateDialogComponent,
        SocialLinksStyleFieldComponent,
        WireRegionSelectComponent,
        WireRegionSelectDialogComponent
    ],
    exports: [
        WireComponent
    ],
    providers: [
        WireService,
        WirePageBuilderService,
        {
            provide: AbstractHypeService,
            useClass: WireHypeService
        },
        WireReportService,
        WirePlainTextService
    ]
})
export class WireModule { }
